import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border h-[18px] font-normal rounded-[4px] py-[1px] px-[6px] text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-primary bg-primary text-primary-foreground hover:bg-primary/80',
        destructive: 'inline-flex border-destructive bg-destructive text-destructive hover:bg-destructive/80',
        success: 'inline-flex border-success bg-success text-success hover:bg-success/80',
        warning: 'inline-flex border-warning bg-warning text-warning hover:bg-warning/80',
        disabled: 'inline-flex border-disabled bg-disabled text-disabled hover:bg-disabled/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
